import React from 'react';
import SupplierBadge from './SupplierBadge';
import SupplierLocation from './SupplierLocation';

function SupplierCard({
  name,
  shortcode,
  caption,
  logo_url,
  tier,
  city,
  state,
  country,
  rating,
  year_established,
}) {
  return (
    <div className="supplierCard">
      <div className="supplierCardContent">
        <a
          href={`/supplier_profiles/${shortcode}`}
          className="supplierCardLink"
          target="_blank"
          rel="noopener noreferrer"
        >
          {logo_url && (
            <img src={logo_url} alt={name} className="supplierCardLogo" />
          )}
          <div className="supplierCardNameContainer" style={{ minHeight: '2.5rem' }}>
            <p className="title is-6 mb-1 supplierCardName">{name}</p>
          </div>
          <div className="supplierCardDescriptionContainer" style={{ minHeight: '3rem' }}>
            <p className="supplierCardDescription">{caption}</p>
          </div>
          <div className="my-3" style={{ minHeight: '2rem' }}>
            <SupplierBadge tier={tier} />
          </div>
          <div style={{ minHeight: '1.5rem' }}>
            <SupplierLocation city={city} state={state} country={country} />
          </div>
          <div className="supplierCardDetails" style={{ minHeight: '1.5rem' }}>
            {rating && (
              <span className="mr-4">
                {rating} <i className="ph-fill ph-star reviewStar"></i>
              </span>
            )}
            {year_established && <span>Est. {year_established}</span>}
          </div>
        </a>
      </div>
      <a
        href={`/supplier_profiles/${shortcode}`}
        className="button is-rounded contactSupplierButton"
        target="_blank"
        rel="noopener noreferrer"
      >
        Contact supplier
      </a>
    </div>
  );
}

export default SupplierCard;
